import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { OrderReminderStateData } from "@TKCCP/Store/CustomHandlerCreator/OrderReminderStateData";
import { Draft } from "immer";

const initialState: OrderReminderStateData = {
    isLoading: false,
    EmailReminderforOrders: undefined,
};

const reducer = {
    "Data/AttributeValues/BeginLoadmailReminderforOrders": (
        draft: Draft<OrderReminderStateData>,
        action: { EmailReminderforOrders: boolean },
    ) => {
        draft.isLoading = true;
    },
    "Data/AttributeValues/CompleteLoadmailReminderforOrders": (
        draft: Draft<OrderReminderStateData>,
        action: { result: boolean },
    ) => {
        draft.isLoading = false;
        draft.EmailReminderforOrders = action.result;
    },
};

export default createTypedReducerWithImmer(initialState, reducer);
